import React from "react";
import { Box, Typography, useTheme } from "@mui/material";

const EmptyIntegrationsState = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        textAlign: "center",
        py: 8,
        px: 4,
        backgroundColor: "#FFFFFF",
        borderRadius: "12px",
        border: `1px solid ${theme.customColors.border.main}`,
        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
      }}
    >
      <Typography variant="body1" color={theme.customColors.text.secondary}>
        No integrations found
      </Typography>
    </Box>
  );
};

export default EmptyIntegrationsState;
